<template>
<svg viewBox="0 0 705 713" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="this.lang === 'ru'">
    <g id="Group 782">
    <g id="employees">
    <rect id="Rectangle 4009" x="357" width="348" height="352" fill="#F7F7F9"/>
    <text id="3" fill="#0B2C62" xml:space="preserve" style="white-space: pre" font-size="22" letter-spacing="0em"><tspan x="497.491" y="126.221">3. Развитие</tspan><tspan x="497.491" y="157.221">сотрудников</tspan></text>
    </g>
    <g id="principles">
    <rect id="Rectangle 4009_2" width="348" height="352" fill="#F7F7F9"/>
    <text id="2" fill="#0B2C62" xml:space="preserve" style="white-space: pre" font-size="22" letter-spacing="0em"><tspan x="82.082" y="126.221">2. Принципы</tspan><tspan x="78.1074" y="157.221">«Распадской»</tspan></text>
    </g>
    <g id="management">
    <rect id="Rectangle 4009_3" y="361" width="348" height="352" fill="#F7F7F9"/>
    <text id="4" fill="#0B2C62" xml:space="preserve" style="white-space: pre" font-size="22" letter-spacing="0em"><tspan x="78.0303" y="561.221">4. Эффективное</tspan><tspan x="78.0303" y="592.221">управление</tspan></text>
    </g>
    <g id="processes">
    <rect id="Rectangle 4009_4" x="357" y="361" width="348" height="352" fill="#F7F7F9"/>
    <text id="5" fill="#0B2C62" xml:space="preserve" style="white-space: pre" font-size="22" letter-spacing="0em"><tspan x="407.324" y="561.221">5. Совершенствование</tspan><tspan x="407.324" y="592.221">процессов</tspan></text>
    </g>
    <g id="center">
    <rect id="Rectangle 4009_5" x="353" y="180" width="250" height="250" transform="rotate(45 353 180)" fill="white"/>
    <text id="1" fill="#2F2E34" xml:space="preserve" style="white-space: pre" font-size="22" letter-spacing="0em"><tspan x="268.198" y="348.221">1. Амбициозная</tspan><tspan x="327.892" y="379.221">цель</tspan></text>
    </g>
    </g>
</svg>
<svg viewBox="0 0 705 713" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
    <g id="Group 782">
    <g id="employees">
    <rect id="Rectangle 4009" x="357" width="348" height="352" fill="#F7F7F9"/>
    <text id="3" fill="#0B2C62" xml:space="preserve" style="white-space: pre" font-size="22" letter-spacing="0em"><tspan x="497.491" y="126.221">3. People</tspan><tspan x="497.491" y="157.221">Development</tspan></text>
    </g>
    <g id="principles">
    <rect id="Rectangle 4009_2" width="348" height="352" fill="#F7F7F9"/>
    <text id="2" fill="#0B2C62" xml:space="preserve" style="white-space: pre" font-size="22" letter-spacing="0em"><tspan x="82.082" y="126.221">2. Principles</tspan><tspan x="78.1074" y="157.221">of Raspadskaya</tspan></text>
    </g>
    <g id="management">
    <rect id="Rectangle 4009_3" y="361" width="348" height="352" fill="#F7F7F9"/>
    <text id="4" fill="#0B2C62" xml:space="preserve" style="white-space: pre" font-size="22" letter-spacing="0em"><tspan x="78.0303" y="561.221">4. Efficient</tspan><tspan x="78.0303" y="592.221">management</tspan></text>
    </g>
    <g id="processes">
    <rect id="Rectangle 4009_4" x="357" y="361" width="348" height="352" fill="#F7F7F9"/>
    <text id="5" fill="#0B2C62" xml:space="preserve" style="white-space: pre" font-size="22" letter-spacing="0em"><tspan x="497.491" y="561.221">5. Process</tspan><tspan x="497.491" y="592.221">improvement</tspan></text>
    </g>
    <g id="center">
    <rect id="Rectangle 4009_5" x="353" y="180" width="250" height="250" transform="rotate(45 353 180)" fill="white"/>
    <text id="1" fill="#2F2E34" xml:space="preserve" style="white-space: pre" font-size="22" letter-spacing="0em"><tspan x="290" y="348.221">1. Ambitious</tspan><tspan x="320" y="379.221">target</tspan></text>
    </g>
    </g>
</svg>

</template>
<script>

export default {
    data () {
        return {
            lang: this.$root.lang,
            items: ['employees', 'principles', 'management', 'center', 'processes']
        }
    },
    props: {
        value: {
            type: String
        }
    },
    methods: {
        emit (el) {
            this.$emit('input', el)
        },
        changeActive (element) {
            this.items.forEach(el => {
                const element = document.querySelector(`#${el}`)
                element.classList.remove('active')
            })

            element.classList.add('active')
        },
        eventHandler (el, element) {
            this.emit(el)
            this.changeActive(element)
        }
    },
    // computed: {
    //     text () {
    //         return window.App.page.lang === 'ru' ? this.textRu : this.textEn
    //     }
    // },
    mounted () {
        this.items.forEach(el => {
            const element = document.querySelector(`#${el}`)
            if (this.value === el) {
                element.classList.add('active')
            }
            element.classList.add('interactive')

            element.addEventListener('click', (e) => {
                this.eventHandler(el, element)
            })
        })
    },
    beforeDestroy () {
        this.items.forEach(el => {
            const element = document.querySelector(`#${el}`)
            element.removeEventListener('click', (e) => {
                this.eventHandler(el, element)
            })
        })
    }
}
</script>

<style lang="scss" scoped>
svg {
    font-family: FranklinGothicITC, Helvetica, sans-serif;
    font-weight: 600;
    letter-spacing: normal;
    line-height: 1.2;
    font-size: 22px;
    overflow: visible;

    * {
        overflow: visible !important;
    }
}

.interactive {
    cursor: pointer;
    &:hover{
        rect {
            fill: #E8E6ED !important;
            filter: drop-shadow(0px 100px 80px rgba(55, 56, 58, 0.15));
            transition: all ease .2s;
        }
    }
}

.active {
    pointer-events: none;
    position: relative;
    z-index: 2;

    rect {
        fill: #E8E6ED !important;
        transition: all ease .2s;
        filter: drop-shadow(0px 100px 80px rgba(55, 56, 58, 0.15));
    }
}
</style>
